module.exports = __webpack_public_path__ + "static/media/homeoff.306eb9a4.svg";